var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-main"},[_c('e-tabs',{attrs:{"list":this.$constant.tabListDangan(),"isJump":""}}),_c('div',[_vm._v("家庭成员")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }